module.exports = __webpack_public_path__ + "img/logo-ai-light-mode.26d8b0e4.svg";